import useFeatureFlag from '@/modules/feature_flag/useFeatureFlag';

export function useDisplayNotificationIndex() {
  const [displayNotificationsIndex] = useFeatureFlag(
    'v2_display_notification_index',
  );

  return { displayNotificationsIndex };
}
